import $ from "jquery"
import _ from "../utils/lodash"
import { getOptions, setOptions, getDimention } from "./variables"
import { sendMail } from "./sendmail"
import { selectedVisible } from "./mfpTootls"

const imagetag_confirm =
  '<img src="form/images/inquiry_s_02.png" width="642" height="32" alt="CONFIRM" />'
const imagepath_send = "form/images/mfp_send.gif"
const imagepath_cancel = "form/images/mfp_cancel.gif"

export const openConfirmView = (texts) => {
  const { confirmWrap } = getOptions()

  confirmWrap.style.visibility = "visible"

  setTimeout(() => {
    confirmWrap.className = "open"
  }, 100)

  toggleScrolling(true)
  let $inner = $(`<div class="confirm--inner">`)
  let $wrap = $(`<div class="confirm--wrap">`).append($inner)
  $(confirmWrap).append($wrap)

  $inner.append(createHead()).append(createBody(texts)).append(createFooter())
}

const closeConfirmView = () => {
  const { confirmWrap } = getOptions()
  confirmWrap.className = ""
  toggleScrolling(false)

  setTimeout(() => {
    confirmWrap.style.visibility = "hidden"
    $(confirmWrap).children().remove()
    setOptions({ mailformObj: undefined })
  }, 800)
}

const toggleScrolling = (open) => {
  if (open) {
    const { scrollTop } = getDimention()
    $("body").css({
      top: -1 * scrollTop,
      position: "fixed",
      left: 0,
      width: "100vw",
      overflow: "hidden",
    })
    setOptions({ savedScrollTop: scrollTop })
  } else {
    const { savedScrollTop } = getOptions()
    $("body").css({
      top: "",
      position: "",
      left: "",
      width: "",
      overflow: "",
    })
    $(window).scrollTop(savedScrollTop)
  }
}

const createHead = () => {
  const $stepper = `<div class="confirm--title">${imagetag_confirm}</div>`
  const $head = $("h1").clone()
  return $(`<div class="confirm--title_wrap">`).append($head).append($stepper)
}

const createBody = (texts) => {
  const $bodyWrap = $(`<dl class="confirm--body_wrap">`)
  const contents = texts.map(({ name, text }) => {
    return `<dt><span>${name}</span></dt><dd>${text}</dd>`
  })
  $bodyWrap.append(contents)

  return $bodyWrap.wrap(`<div class="confirm--body"></div>`)
}

const createFooter = () => {
  const $buttonsWrapper = $('<div class="confirm--buttons">')

  const cancelImage = new Image()
  cancelImage.src = imagepath_cancel
  cancelImage.alt = "Cancel"

  const $buttonCancel = $(`<button></button>`)
  $buttonCancel.append(cancelImage)
  $buttonCancel.on("click", (e) => {
    e.preventDefault()
    setOptions({ check_flag: {} })
    closeConfirmView()
    selectedVisible()
  })

  const sendImage = new Image()
  sendImage.src = imagepath_send
  sendImage.alt = "Send"

  const $buttonSend = $(`<button></button>`)
  $buttonSend.append(sendImage)
  $buttonSend.on("click", (e) => {
    e.preventDefault()
    const { obj, loading } = getOptions()
    if (!loading) {
      const loading_image = `<img src="form/images/mfp_loading.gif" id="loading_proccess_image" width="40" height="40" />`

      setOptions({
        loading: $(`<div id="loading">`)
          .append(loading_image)
          .appendTo("body")
          .addClass("open"),
      })
    }
    setOptions({ mailformObj: obj })
    sendMail(obj)
  })

  return $buttonsWrapper.append($buttonCancel).append($buttonSend)
}
